import React from 'react';
import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';

import styles, {
  checkboxCustomStyles,
  textfieldsStyles,
  selectCustomStyles
} from '../styles/informationSection';
import InputRow from '../../../partials/dataRows/InputRow';
import SelectRow from '../../../partials/dataRows/SelectRow';
import { isDefined, isUndefined } from '../../../utils/isDefined';
import PassStrengthMeter from '../../../partials/passStrengthMeter/PassStrengthMeter';
import withUserCheck from '../../../utils/withUserCheck';
import CheckboxRow from '../../../partials/dataRows/CheckboxRow';
import { translate } from '../../../i18n/I18nProvider';
import compareIds from '../../../utils/compareIds';

export function shouldShowPartnerAdmin({
  isPartnerOrDstnyAdmin,
  loggedUser,
  user = {}
}) {
  return (
    isPartnerOrDstnyAdmin &&
    (loggedUser?.partner_admin === true ||
      loggedUser?.['is_super_admin?'] === true) &&
    compareIds(user.client?.partner?.client?.id, user.client_id)
  );
}

const InformationSection = ({
  classes,
  form,
  selectsOptions = {},
  isAdminUser,
  user = {},
  isDomainProvided,
  isPartnerOrDstnyAdmin,
  loggedUser,
  isSuperAdmin
}) => {
  return (
    <div className={classes.root}>
      <div className={classes.label}>{translate('EDIT.INFO')}</div>
      <div className={classes.container}>
        <div>
          <InputRow
            label="TABLE.NAME"
            name="name"
            customStyles={textfieldsStyles}
            {...form}
          />
          <InputRow
            label="TABLE.USERNAME"
            name="username"
            disabled={isDefined(user.id) ? true : false}
            infoIcon={true}
            customStyles={textfieldsStyles}
            infoIconTooltipIntlKey={'TOOLTIP.USERNAME_INFO'}
            {...form}
          />
          <InputRow
            name="email"
            label="TABLE.EMAIL"
            customStyles={textfieldsStyles}
            {...form}
          />
          {isUndefined(user.id) && (
            <CheckboxRow
              label="USER.SEND_INVITATION_EMAIL"
              name="generate_welcome_email"
              customStyles={checkboxCustomStyles}
              infoIcon={true}
              infoIconTooltipIntlKey="TOOLTIP.SEND_INVITATION_EMAIL"
              {...form}
            />
          )}
          <>
            <InputRow
              name="pass"
              label="EDIT.PASS"
              disabled={form.values.generate_welcome_email}
              customStyles={textfieldsStyles}
              {...form}
            />
            <PassStrengthMeter pass={form.values.pass} />
          </>
          {shouldShowPartnerAdmin({
            isPartnerOrDstnyAdmin,
            loggedUser,
            user
          }) && (
            <CheckboxRow
              label="USER.SET_PARTNER_ADMIN"
              name="partner_admin"
              customStyles={checkboxCustomStyles}
              {...form}
            />
          )}
          <SelectRow
            name="language"
            label="LANG"
            options={selectsOptions.language}
            customStyles={selectCustomStyles}
            {...form}
          />
          {isDomainProvided && (
            <SelectRow
              name="connect30_user_id"
              label="DOMAIN_NAME"
              options={selectsOptions.telephony_users}
              isDisabled={!isAdminUser}
              menuPlacement={'top'}
              customStyles={selectCustomStyles}
              {...form}
            />
          )}
          <InputRow
            name="provider"
            label="SSO_CONNECTION"
            disabled={!isSuperAdmin}
            customStyles={textfieldsStyles}
            {...form}
          />
          <InputRow
            name="uid"
            labelText="SSO ID"
            disabled={!isSuperAdmin}
            customStyles={textfieldsStyles}
            {...form}
          />
        </div>
      </div>
    </div>
  );
};

const mapStatesToProps = ({ editUser, auth }) => {
  return {
    user: editUser.user,
    loggedUser: auth.user
  };
};

export default flowRight(
  withUserCheck,
  connect(mapStatesToProps),
  withStyles(styles)
)(InformationSection);
